import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";

const StatusFilter = ({ selectedStatus, setSelectedStatus }) => {
  const status = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
  ];

  return (
    <div className="timesheet_dropdown_wrapper">
      <SelectDropdown
        options={status}
        value={selectedStatus}
        setSelectedOption={setSelectedStatus}
        name="Status"
        isDisable={false}
        isSearchable={false}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default StatusFilter;
